export default "__VITE_ASSET__C5ljLce___"